<!--
 * @Author: your name
 * @Date: 2020-11-18 15:08:50
 * @LastEditTime: 2021-07-02 14:12:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \znjz-vue\src\components\news\noticeDetail.vue
-->
<template>
  <div class="notice-det">
      <div class="type-page">
          <h1>{{titleName}}</h1>
          <p>作者：<span>{{user_text}}</span> &nbsp;&nbsp;发布于：<span>{{create_time_str}} </span>&nbsp;&nbsp; 浏览：<span>{{view_count}}</span></p>
      </div>
      <div class="content">
         <div class="type-page clearfix">
              <div class="content-text">
                  <p  v-html="content">{{content}}</p>
              </div>
             <Notice :title="title" :rightList="rightList" :path="path" />
         </div>
      </div>
  </div>
</template>

<script>
import Notice from './../news/components/notice'
import {getNewsDetailApi} from './../../api/api'
export default {
    components: {
        Notice,
    },
    data(){
        return {
            newId: this.$route.query.id,
            title: '热门动态',
            titleName: '',
            path: '/noticeDetail',
            content: '',
            create_time_str: '',
            view_count: '',  
            user_text: '',
            pid:1,
            rightList: [],
        }
    },
    mounted(){
        this.GetDetail()
         
         //监听浏览器后退按钮
        if (window.history && window.history.pushState) {
            history.pushState(null, null, document.URL);
            window.addEventListener('popstate', this.goBack, false);
        }
    },
    methods:{
         goBack () {
            this.$router.push({
                name: 'news',
                params: {
                    tabs: this.pid,
                    lang: this.$route.query.lang
                }
            })
        }, 


        //获取详情
       GetDetail(){
           const params = {
               id:this.newId,
               count: 1,
               lang: localStorage.getItem('lang')
           }
         getNewsDetailApi(params).then(res => {
             
             if(res.data.code == 0){
                 const {title, content,create_time, view_count,user_text,pid} = res.data.data.news
                 this.titleName = title
                 this.content = content
                 this.create_time_str = create_time
                 this.view_count = view_count
                 this.user_text = user_text
                 this.pid = pid
                 this.rightList = res.data.data.rightList
             }else {
                  this.$message.warning(res.data.msg);
             }
        }).catch(err => {
            this.$message.error(err);
        })
       }
    },

    //销毁监听
    destroyed(){
        window.removeEventListener('popstate', this.goBack, false);
    }
}
</script>

<style scoped lang="scss">
.notice-det{
    background-color: #f5f5f5;
    h1 {
        font-size: 18px;
        font-weight: bold;
        line-height: 22px;
        padding-top: 79px;
    }
    p{
        color: #999;
        font-size: 16px;
        line-height: 26px !important;
        padding: 30px 0 40px ;
    }
}
.content {
    background-color: #fff;
}
.content-text {
    width: 65%;
    float: left;
    font-size: 16px;
    color: #666;
    padding: 15px;
    >>> img {
        // width: 100% !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/news/noticeDetail.vue